import {useIsMutating} from "@tanstack/react-query";
import {Alert, Button, Col, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useCreateSubscriptionContext} from "../../context/create-subscription";
import {useGetSubscriptionApi} from "../../../../../react-query-hooks/store/subscriptions/get-subscription";
import {
  SUBSCRIPTION_COVER_IMAGE_DELETE_MUTATION_KEY,
  SUBSCRIPTION_COVER_IMAGE_UPLOAD_MUTATION_KEY,
} from "../../../../../react-query-hooks/store/subscriptions/constants";
import {SubscriptionCoverImagesBlock} from "../../../subscription-cover-images-block";
import {FormWrapper} from "../../../../../components/form-wrapper";

export function CreateSubscriptionCoverImagesUploadStep() {
  const {
    dispatch,
    state: {apiResponseData},
  } = useCreateSubscriptionContext();

  const subscriptionId = apiResponseData?.productSubscription?.id;
  const getSubscriptionApiQuery = useGetSubscriptionApi(subscriptionId);

  const subscription =
    getSubscriptionApiQuery.data?.productSubscription ??
    apiResponseData?.productSubscription;
  const subscriptionIdForUpload = subscription?.id ?? subscriptionId ?? 0;

  const coverImageMutationsBusy =
    useIsMutating({mutationKey: [SUBSCRIPTION_COVER_IMAGE_UPLOAD_MUTATION_KEY]}) +
      useIsMutating({mutationKey: [SUBSCRIPTION_COVER_IMAGE_DELETE_MUTATION_KEY]}) >
    0;

  if (getSubscriptionApiQuery.isError && !apiResponseData) {
    return (
      <Alert
        message="Error"
        description={getSubscriptionApiQuery.error?.message}
        type="error"
        showIcon
      />
    );
  }

  if (!subscriptionIdForUpload) {
    return (
      <Alert
        message="Error"
        description="No subscription found. Please go back and complete the subscription information first."
        type="error"
        showIcon
      />
    );
  }

  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <FormWrapper borderless>
          <SubscriptionCoverImagesBlock
            subscriptionId={subscriptionIdForUpload}
            fallbackProductSubscription={
              apiResponseData?.productSubscription ?? undefined
            }
          />
        </FormWrapper>
        <Row gutter={[0, 16]}>
          <Col span={24} sm={12}>
            <StyledServiceButtonWrapper>
              <Button
                onClick={() =>
                  dispatch({
                    type: "update-create-subscription-form-step",
                    payload: "basicForm",
                  })
                }
                block
                size="small"
                type="default"
              >
                Back
              </Button>
              <Button
                block
                type="primary"
                size="small"
                onClick={() =>
                  dispatch({
                    type: "update-create-subscription-form-step",
                    payload: "automations",
                  })
                }
                disabled={coverImageMutationsBusy}
              >
                Next
              </Button>
            </StyledServiceButtonWrapper>
          </Col>
        </Row>
      </Space>
    </div>
  );
}
